import { Info } from "lucide-react";

import { Alert, AlertDescription } from "../../../components/ui/alert";
import { getIntegrationLimitationNote } from "../../utils";

type LimitationNoteProps = {
  sourceId: string;
};

export function LimitationNote({ sourceId }: LimitationNoteProps) {
  const note = getIntegrationLimitationNote(sourceId);
  if (!note) return null;

  return (
    <Alert
      role="note"
      className="bg-zinc-50 dark:bg-neutral-900 border-zinc-200 dark:border-neutral-700"
    >
      <Info className="h-4 w-4" />
      <AlertDescription className="text-zinc-600 dark:text-zinc-300 leading-6">
        {note}
      </AlertDescription>
    </Alert>
  );
}
